<template>
  <div>
    <b-card class="mb-2 shadow bg-light">
      <b-card-title title-tag="h6">Indemnités</b-card-title>
      <b-table
        v-if="indemnities.length > 0"
        id="indemnitiesTable"
        responsive
        striped
        small
        hover
        :fields="indemnitiesFields"
        :items="indemnities"
      >
        <template v-slot:cell(montant)="data"
          >{{ twoDigits(data.item.montant) }} €</template
        >

        <template v-slot:bottom-row>
          <td />
          <td />
          <td>
            <strong>Total</strong>
          </td>
          <td>
            <strong>
              <span class="float-right"
                >{{
                  indemnities
                    .filter((x) => x.paye == "non")
                    .reduce((a, b) => a + parseFloat(b.montant), 0)
                    .toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                }}
                €</span
              >
            </strong>
          </td>
          <td />
        </template>
      </b-table>
      <b-card-body v-else>
        <b-alert show>Pas d'indemnités</b-alert>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import DateTime from "@/services/DateTime.js";
import warrants from "@/services/warrants.js";
export default {
  name: "warrant-indemnities",
  props: ["id"],
  components: {},
  data() {
    return {
      loaded: false,
      indemnities: [],
      indemnity_id: null,
      warrant_id: null,
     
      indemnitiesFields: [
        {
          key: "type",
          label: "Type",
          sortable: true,
          formatter: (value) => {
            switch (value) {
              case "frais dossier":
                return "Frais de dossier";
              case "interet":
                return "Intérêt";
              case "clause penale":
                return "Clause pénale";
              case "divers":
                return "Divers";
              case "frais de mise en demeure":
                return "Frais de mise en demeure";
              case "frais de recouvrement":
                return "Frais de recouvrement";
              case "frais de deplacement":
                return "Frais de déplacement";
              default:
                return "Indemnité";
            }
          },
        },

        {
          key: "note",
          label: "Note",
          sortable: false,
        },
        {
          key: "paye",
          label: "Payé",
          sortable: true,
        },
        {
          key: "montant",
          label: "Montant",
          sortable: true,
          class: "text-right",
        },
      ],
    };
  },
  created() {
    this.load();
  },
  methods: {
   
    load(emit = false) {
      warrants.indemnities(this.$props.id).then((response) => {
        this.indemnities = response.data;
        this.loaded = true;
        if (emit) {
          this.$emit("change");
        }
      });
    },
   
    toDate(d) {
      return DateTime.humanDate(d);
    },
    twoDigits(value) {
      return Number(value).toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>